import { render, staticRenderFns } from "./PrivacyPolicyIndia.vue?vue&type=template&id=04134d77&scoped=true"
import script from "./PrivacyPolicyIndia.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyIndia.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicyIndia.vue?vue&type=style&index=0&id=04134d77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04134d77",
  null
  
)

export default component.exports